<template>
	<!-- eslint-disable -->

	<header id="nav-header" :class="{ 'hero': $route.name == 'Home' }">

		<template v-if="$route.name == 'Home' || $route.name == 'Manifesto'">

			<div id="hero" class="hero__background">
				<img
					v-if="$route.name == 'Home'"
					:src="'bridgerocks-world-bg.webp' | assetsImg"
					alt="BridgeRocks"
				>

				<img
					v-if="$route.name == 'Manifesto'"
					:src="'manifesto1.webp' | assetsImg"
					alt="BridgeRocks Hero"
				>
			</div>

			<div class="hero__overlay"></div>
			<div class="hero__glow"></div>
			<div class="hero__pattern"></div>

		</template>

		<nav class="navbar">

			<router-link to="/" class="navbar__logo">

				<span>
					<i
						v-if="$route.name != 'Home'"
						class="fa-solid fa-arrow-left"
					></i>

					<i
						v-else
						class="fa-solid"
					></i>
				</span>

				<img
					:src="'logo1.webp' | assetsImg"
					alt="BridgeRocks"
				>

			</router-link>

			<ul class="navbar__menu">

				<li
					v-for="(item, key) in navigation"
					:key="key"
					class="no-break"
				>
					<a :href="item.href | cr">
						{{ item.label | i18n }}
					</a>
				</li>

			</ul>

			<div class="navbar__actions">

				<a href="#contact" class="navbar__contact">
					{{ 'Connect With Us' | i18n }}
				</a>

				<div class="navbar__language">

					<a href="#" class="language__current uppercase">
						{{ langUserGet | uppercase }}
						<i class="fa-solid fa-angle-down"></i>
					</a>

					<ul class="language__menu">

						<li
							v-for="lang in langs"
							:key="lang.key"
						>
							<a
								href="#"
								:data-lang="lang.key"
								@click.prevent="setLang(lang.key)"
							>
								{{ lang.label | i18n }}
							</a>
						</li>

					</ul>

				</div>

			</div>

			<button
				class="menu-toggle"
				aria-label="Open Menu"
				:class="{ 'active': isMenuOpen }"
				@click="toggleMenu"
			>
				<span></span>
				<span></span>
				<span></span>
			</button>

		</nav>

		<div
			class="mobile-overlay"
			:class="{ 'active': isMenuOpen }"
		></div>

		<div
			class="mobile-menu"
			:class="{ 'active': isMenuOpen }"
		>

			<div class="mobile-menu__header">

				<a href="#hero" class="mobile-menu__logo">

					<img
						:src="'logo1.webp' | assetsImg"
						alt="BridgeRocks"
					>

				</a>

				<button
					class="mobile-menu__close"
					aria-label="Close Menu"
					:class="{ 'active': isMenuOpen }"
					@click="toggleMenu"
				>
					<i class="fa-solid fa-xmark"></i>
				</button>

			</div>

			<nav class="mobile-menu__nav">

				<ul>

					<li
						v-for="(item, key) in navigation"
						:key="key"
					>
						<a :href="item.href | cr">
							{{ item.label | i18n }}
						</a>
					</li>

					<li class="mobile-menu__contact">
						<a href="#contact">
							{{ 'Connect With Us' | i18n }}
						</a>
					</li>

				</ul>

			</nav>

			<div class="mobile-menu__language">

				<span>
					Language
				</span>

				<a
					href="#"
					v-for="lang in langs"
					:key="lang.key"
					:data-lang="lang.key"
					@click.prevent="setLang(lang.key)"
				>
					{{ lang.label | i18n }}
				</a>

			</div>

		</div>

	</header>
</template>

<script>
/* eslint-disable */
import { langUserSet, langUserGet } from '@/utils.js';

export default {
	name: "navHeader",

	props: {
		navigation: {
			type: Object,
			default: () => ({
				home: {
					key: "home",
					label: "Home",
					href: "/"
				},

				corporate: {
					key: "corporate",
					label: "Corporate Services",
					href: "site_br_bridgerocks"
				},

				reyrock: {
					key: "reyrock",
					label: "Opportunity Portfolio",
					href: "site_br_reyrock_landing"
				},

				manifest: {
					key: "manifesto",
					label: "Manifesto",
					href: "/manifesto"
				}
			})
		},

		langs: {
			type: Array,
			default: () => [
				{ key: "en", label: "English" },
				{ key: "fr", label: "Français" },
				{ key: "es", label: "Español" }
			]
		}
	},

	computed: {
		langUserGet
	},

	data: () => {
		return {
			isMenuOpen: false
		};
	},

	methods: {
		setLang(lang) {
			langUserSet(lang);
			document.location.reload();
		},

		toggleMenu() {
			this.isMenuOpen = !this.isMenuOpen;

			if (this.isMenuOpen) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "";
			}
		}
	},

	mounted() {
		setTimeout(() => {
			const navbar = document.querySelector('.navbar');

			if (window.scrollY >= 10) {
				navbar.classList.add('scrolled');
			}
		}, 100);
	}
};
</script>

<style lang="scss">
#nav-header {

	.navbar {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		width: 100%;
		gap: 0;
	}

	.navbar__logo {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex-shrink: 0;

		&:hover {
			color: #B45D2D;
		}

		span {
			font-size: 20px;
			transition: .3s;
		}

		img {
			width: 190px;
			height: auto;
		}
	}

	.navbar__menu {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		min-width: 0;
		gap: clamp(22px, 3vw, 60px);
		margin: 0 24px;
		padding: 0;

		li {
			flex-shrink: 0;
		}

		a {
			white-space: nowrap;
		}
	}

	.navbar__actions {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 16px;
		flex-shrink: 0;
	}

	.navbar__contact {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 42px;
		padding: 0 18px;
		border: 1px solid #D2AB5B;
		border-radius: 4px;
		color: #FFFFFF;
		font-size: 12px;
		font-weight: 600;
		letter-spacing: .5px;
		text-transform: uppercase;
		white-space: nowrap;
		flex-shrink: 0;
		transition: .3s;

		&:hover {
			background: #D2AB5B;
			color: #0F1824;
		}
	}

	.navbar__language {
		flex-shrink: 0;

		.language__current {
			white-space: nowrap;
		}
	}

	.menu-toggle {
		display: none;
		flex-shrink: 0;
	}

	.mobile-menu__contact a {
		color: #D2AB5B;
	}

	.navbar.scrolled {
		background: rgba(15, 24, 36, 0.65);
	}

	@media (max-width: 1500px) {

		.navbar__logo img {
			width: 175px;
		}

		.navbar__menu {
			gap: 28px;
			margin: 0 18px;

			a {
				font-size: 15px;
			}
		}

		.navbar__actions {
			gap: 12px;
		}

		.navbar__contact {
			height: 40px;
			padding: 0 14px;
			font-size: 11px;
		}
	}

	@media (max-width: 1350px) {

		.navbar__logo img {
			width: 160px;
		}

		.navbar__menu {
			gap: 20px;
			margin: 0 14px;

			a {
				font-size: 14px;
			}
		}

		.navbar__actions {
			gap: 10px;
		}

		.navbar__contact {
			height: 38px;
			padding: 0 12px;
			font-size: 10px;
			letter-spacing: .3px;
		}

		.navbar__language {

			.language__current {
				font-size: 13px;
			}
		}
	}

	@media (max-width: 1280px) {

		.navbar__menu,
		.navbar__actions {
			display: none;
		}

		.navbar__logo img {
			width: 190px;
		}

		.menu-toggle {
			display: flex !important;
			margin-left: auto;
		}
	}

	@media (min-width: 1281px) {

		.menu-toggle {
			display: none !important;
		}
	}
}
</style>